import { SuperLink as Link } from "@/components/common/super-link";
import { ChevronRightIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

export const ExamPageTypeLink = ({
  text,
  link,
  tooltip,
}: {
  text: string;
  link?: string;
  tooltip?: string;
}) => {
  const styles = `flex items-center justify-between p-4 rounded-[10px] border w-full`;
  const Wrapper = ({ children }: { children: ReactNode }) =>
    !link ? (
      <div className={cn(styles, "opacity-25")} data-title={tooltip}>
        {children}
      </div>
    ) : (
      <Link
        href={link}
        className={cn(styles, "transition-all hover:scale-101 active:scale-99")}
      >
        {children}
      </Link>
    );

  return (
    <Wrapper>
      <span className={`text-foreground text-sm font-normal`}>{text}</span>
      <ChevronRightIcon size={16} />
    </Wrapper>
  );
};
